import { createSelector } from 'reselect';

import getEntities from './entities';

export const getSystemMessages = createSelector(getEntities, entities => entities.systemMessages);

export const getSystemMessage = createSelector(getEntities, entities => entities.systemMessage);
